export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10950.39227dc9.jpg";